import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { locales } from "../../../../constants/constants";
import { setSkillsStatusState } from "../../state/skillsstatus/actions";
import { domainInfo } from "../../util/domainInfo";
import Tooltip from "rc-tooltip";

import "./domainpicker.scss";
import "rc-tooltip/assets/bootstrap_white.css";
import { GetBrandedAppName } from "../../../../services/BrandingService";
import { useTranslation } from "react-i18next";

// List of unsupported buttons/domains in each Language
const unsupportedOrDisabledBtns = {
  [locales.EN_US]: [
    "PHONOLOGICAL_AWARENESS",
  ],
  [locales.ES_MX]: [
    "SIGHT_RECOGNITION",
    "PHONOLOGICAL_AWARENESS",
  ]
};

export default function DomainPicker(props) {
  const domain = useSelector((state) => state.reports.skillsstatus.domain);
  const selectedLocale = useSelector((state) => state.reports.teacher.selectedLocale);
  const dispatch = useDispatch();
  const setState = (state) => dispatch(setSkillsStatusState(state));

  if(!selectedLocale) return null;

  // If we switch to a language where the selected domain is unsupported then default to Decoding,
  // otherwise just use the selected domain
  if(unsupportedOrDisabledBtns[selectedLocale].includes(domain)) {
    setState({ domain: "DECODING" });
  }

  return (
    <div className="domain-buttons-wrapper">
      {Object.keys(domainInfo)
        .filter((d) => !unsupportedOrDisabledBtns[selectedLocale].includes(d))// Filter out unsupported Fields
        .map((dom, index) => {
          const isActive = dom === domain;
          return <DomainButton {...{ dom, isActive, setState }} key={index} />;
        })}
    </div>
  );
}

function DomainButton(props) {
  const { dom, isActive, setState } = props;

  const {t} = useTranslation("reports_sidebar")

  const domainColor = domainInfo[dom].color;

  const style = {
    color: domainColor,
    borderColor: domainColor,
  };
  if (isActive) {
    style.backgroundColor = domainColor;
    style.color = "#fff";
  }
  return (
    <Tooltip
      placement="bottom"
      trigger={dom === "STRUCTURE_REASONING" ? ['hover'] : []}
      overlayStyle={{width: 200, background: 'white' }}
      overlay={<p style={{textAlign: 'center'}}>
        {t("common:sr_coming_soon")}
      </p>}
    >
      <div
        className="domain-picker-button"
        style={style}
        onClick={() => {
          if(dom === "STRUCTURE_REASONING") return;
          setState({ domain: dom })
        }}
      >
        {t(domainInfo[dom].name)}
      </div>
    </Tooltip>
  );
}
